import { FC, useEffect, useState } from 'react';
import { urlParams } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import { useGlobalAliases } from '@/common/hook/useGlobalAlias';
import { useGetShareContent } from '@/common/hook/useShareContent';
// import { useGetShareContent } from '@/common/hook/useShareContent';
import styles from './entry.module.less';
import BasicLayout from 'src/layout/BasicLayout';
import Container from '@/common/components/business/ExpandStore/ChanceDetailDrawer/Container';
import ChanceCreateDrawer from '@/common/components/business/ExpandStore/ChanceCreateDrawer';

/**
 * 机会点详情页
 * @description
 * @demo
 */
const Component:FC<{}> = () => {

  /* state */
  const [id, setId] = useState(null);

  /** 获取全局别名 */
  const {
    standardChancePoint: standardChancePointAlias, // 机会点别名
  } = useGlobalAliases();

  const { shareId, shareParams } = useGetShareContent({ onSuccess: (params) => methods.init(params) });
  /** 分享时调用接口需要的数据，如果有值代表“分享时” */
  const shareData = shareId && shareParams ? { tenantId: shareParams?.tenantId, userId: shareParams?.employeeId, employeeId: shareParams?.employeeId, shareId } : null;
  // employeeId 用来传递给选址地图组件的参数 shareId 点位测评组件的入参

  const [refreshDetail, setRefreshDetail] = useState<number>(0);

  const [formDrawerData, setFormDrawerData] = useState<any>({
    open: false,
    templateId: '', // 模板id
    id: '', // 编辑时的id
  });

  /* hooks */
  useEffect(() => {
    const id = urlParams(window.location.search)?.id;
    if (id) {
      setId(id);
    }
  }, []);

  useEffect(() => {
    methods.updateHandle();
  }, [id]);

  /* methods */
  const methods = useMethods({

    init(params) {
      console.log('params', params);
      setId(params?.id);
    },

    // 打开详情页时的编辑表单的刷新详情页
    updateHandle: () => {
      const curVal = refreshDetail + 1;
      setRefreshDetail(curVal);
    },

    onCloseEdit: () => {
      setFormDrawerData({
        open: false,
        templateId: '', // 模板id
        id: '', // 编辑时的id
      });
    },

  });

  return (id ? <BasicLayout>
    <div className={styles.containerWrapper}>
      <Container
        id={id}
        setFormDrawerData={setFormDrawerData}
        hideOperate={!!shareId}
        // 20260430 甜瓜要求拿掉禁用逻辑
        // disabledArea={!!shareId}
        refreshDetail={refreshDetail}
        updateHandle={methods.updateHandle}
        shareData={shareData}
      />

      {/* 创建/编辑机会点 */}
      {!shareId && <ChanceCreateDrawer
        drawerData={formDrawerData}
        chancepointAlias={standardChancePointAlias}
        handleEditSuccessed={methods.updateHandle}
        closeHandle={methods.onCloseEdit}
      />}
    </div>
  </BasicLayout> : <></>);
};

export default Component;
